
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {closeConfirm} from 'redux/modules/ui/confirm/actions'
import Overlay from 'components/Overlay'
import {CSSTransitionGroup} from 'react-transition-group'
import classnames from 'classnames'
import Confirm from 'components/Confirm'

class ConfirmContainer extends React.Component {
  static propTypes = {
    confirmShow: PropTypes.bool,
    confirmProps: PropTypes.object,
    closeConfirm: PropTypes.func,
    animationDuration: PropTypes.number
  }

  static defaultProps = {
    animationDuration: 200
  }

  constructor(props) {
    super(props)
    this.state = {
      isClosingConfirm: false
    }
  }

  render() {
    const {confirmShow, closeConfirm} = this.props
    const {isClosingConfirm} = this.state
    const classNames = classnames('confirm_container', {
      'is-visible': confirmShow || isClosingConfirm
    })
    return (
      <div className={classNames} onClick={closeConfirm}>
        {this.renderOverlay()}
      </div>
    )
  }

  renderOverlay() {
    const {confirmShow, animationDuration} = this.props
    return (
      <Overlay animationDuration={animationDuration} visible={!!confirmShow}>
        <CSSTransitionGroup
          transitionName='modal'
          transitionEnterTimeout={animationDuration}
          transitionLeaveTimeout={animationDuration}
        >
          {this.renderConfirm()}
        </CSSTransitionGroup>
      </Overlay>
    )
  }

  renderConfirm() {
    const {closeConfirm, confirmProps} = this.props
    return <Confirm closeModal={closeConfirm} {...confirmProps} />
  }

  closeConfirm() {
    const {animationDuration} = this.props
    this.setState({'isClosingConfirm': true})
    setTimeout(() => this.setState({'isClosingConfirm': false}), animationDuration)
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...state.ui.confirm
  }
}

export default connect(mapStateToProps, {
  closeConfirm
})(ConfirmContainer)



// WEBPACK FOOTER //
// ./client/containers/ConfirmContainer/index.js